import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";

import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import PublisherDashboard from "./pages/PublisherDashboard";
import EditorSupportModulePreview from "./pages/EditorSupportModulePreview";
import ScoutCenterPage from "./pages/ScoutCenterPage";
import NotFound from "./pages/NotFound";

function getUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

function ProtectedRoute({ allowedRoles, children }) {
  const user = getUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const role = user.role;
  const username = String(user.username || "").toLowerCase().trim();

  // If user is 'edit' or 'editor' or role is edit_admin/editor, allow access to editor panels
  if (allowedRoles && !allowedRoles.includes(role)) {
    if ((username === "edit" || username === "editor" || role === "edit_admin" || role === "editor") && (allowedRoles.includes("edit_admin") || allowedRoles.includes("editor"))) {
      return children;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute allowedRoles={["admin", "master_admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/employee-dashboard"
            element={
              <ProtectedRoute allowedRoles={["employee", "manager"]}>
                <EmployeeDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/publisher-dashboard"
            element={
              <ProtectedRoute allowedRoles={["publisher"]}>
                <PublisherDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/scout-center"
            element={
              <ProtectedRoute allowedRoles={["admin", "master_admin", "scout", "scout_manager"]}>
                <ScoutCenterPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/editor-support"
            element={
              <ProtectedRoute allowedRoles={["publisher", "admin", "master_admin", "edit_admin"]}>
                <EditorSupportModulePreview />
              </ProtectedRoute>
            }
          />

          <Route
            path="/edit-admin"
            element={
              <ProtectedRoute allowedRoles={["edit_admin", "admin", "master_admin", "editor"]}>
                <EditorSupportModulePreview />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
